import { getLoaderByType as getLoaderByTypeLocal } from 'redux/modules/loader';

const getLoaderByType = (type, state) =>
  getLoaderByTypeLocal(type, state.loader);

export default getLoaderByType